import React, { useEffect, useState } from "react";
import { InputActionMeta, default as ReactSelect } from "react-select";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import {
  OptionHeaderTemplateMulti,
  OptionHeaderTemplateSingle,
  OptionTemplateMulti,
  OptionTemplateSingle,
} from "./FxListSelectTemplates";
import {
  Menu,
  MenuList,
  MultiOption,
  SingleOption,
  ValueContainer,
} from "./FxListSelectComponents";
import { Box } from "@mui/material";
import { FxListSelectProps } from "./FxListSelect.props"

const animatedComponents = makeAnimated();

export const FxListSelect = ({
  options,
  onChange,
  onInputChange,
  visibility,
  hideCaption,
  caption,
  className,
  color,
  size,
  error,
  success,
  placeholder,
  disabled,
  isMulti = false,
  valueField,
  displayField,
  columns,
  selectedValue,
  variant,
  dataSource,
  getOptionsAsync,
  searchColumn,
  showSelectedCount,
  searchAcrossColumns,
  optionHeaderTemplate,
  optionTemplate,
  valueType = "array",
  menuWidth,
  menuHeight,
  mandatory,
  localization,
  alignDorpdownRight,
  menuId,
  name,
  inputValue
}: FxListSelectProps) => {
  // const customStyles = {
  //     option: (styles: any, state: any) => ({
  //         ...styles,
  //         zIndex: 1,
  //         height: '35px',
  //     }),
  // }
  console.log("animated", animatedComponents)
  const customStyles = {
    option: (styles: any, options: any) => {
      const { isDisabled, isFocused, isSelected, idx } = options;
      //console.log("options", options)
      const bgColor: any = "#fff";
      //const defaultBgColor: any = '#fff';
      //   const [bgColor, setBgColor] = useState(defaultBgColor);
      //   if (idx % 2 === 0) {
      //     setBgColor('rgb(255, 253, 245)');
      //   }

      return {
        ...styles,
        padding: "0",
        height: "32px",
        backgroundColor: isSelected
          ? "#dbeafa"
          : isFocused
            ? "#F5F5F5"
            : bgColor,

        color: isSelected ? "#333" : isFocused ? "#333" : "#333",

        ":active": {
          ...styles[":active"],
          backgroundColor: !isDisabled
            ? isSelected
              ? "#dbeafa"
              : "#F5F5F5"
            : bgColor,
        },
      };
    },
    menu: (provided: any, state: any) => {
      let result: any = {
        ...provided,
      };
      result.zIndex = 999;
      if (state.selectProps.menuWidth) {
        result.width = state.selectProps.menuWidth;
      }
      return result;
    }

  };

  //valueType = array || csv

  const defaultSelected: any = "";
  const [selected, setSelected] = useState(defaultSelected);

  const defaultSelectedItems: any = [];
  const [selectedItems, setSelectedItems] = useState(defaultSelectedItems);

  const defaultSelectAll: any = false;
  const [selectAll, setSelectedAll] = useState(defaultSelectAll);

  const defaults: any = [];
  const [defaultOptions, setDefaultOptions] = useState(defaults);

  const handleChange = (data: any) => {
    console.log('handleChange')
    let selected = data;
    if (valueType != "array") {
      selected = prepareSelected(data);
    }
    if (isMulti && Array.isArray(data)) {
      setSelected(data);
      onChange({ name: name, selected: selected });
      setSelectedItems(data);
    } else {
        setSelected(data);
        onChange({ name: name, value: data[valueField], data: data });
    }
  };

  const selectAllItems = (e: any) => {
    //console.log('selectAll e=', e);
    //console.log('selectAll e.target.checked=', e.target.checked);
    setSelectedAll(e.target.checked);
    if (e.target.checked) {
      handleChange(options);
    } else {
      handleChange([]);
    }
  };

  React.useEffect(() => {
    prepareSelectedArray();
  }, [selectedValue]);

  const prepareSelectedArray = () => {
    if (isMulti && valueType == "array") {
      let list = selectedValue || [];
      setSelected([...list]);
    } else {
      if (dataSource == "remote") {
        if (isMulti) {
          setSelected([...selectedItems]);
        } else {
          if(selectedValue) {
            let selectedOption = { [valueField] : selectedValue, [displayField]: inputValue };
            setSelected(selectedOption);
          } 
        }
      } else {
        if (isMulti) {
          let selectedOptions: any = [];
          if (selectedValue) {
            var selectedArr = selectedValue.split(",");
            selectedOptions = options.filter(
              (option: any) =>
                selectedArr.indexOf(option[valueField].toString()) > -1
            );
            setSelected(selectedOptions);
          }
          setSelected(selectedOptions);
        } else {
          let selectedOption = options.find(
            (option: any) => option[valueField] == selectedValue
          );
          setSelected(selectedOption);
        }
      }
    }
  };

  const prepareSelected = (data: any) => {
    if (isMulti) {
      if (Array.isArray(data)) {
        let resultArr: any = [];
        for (let option of data) {
          resultArr.push(option[valueField]);
        }
        return resultArr.join(",");
      } else {
        return selectedValue;
      }
    } else {
      return data[valueField];
    }
  };

  const filterOption = (
    candidate: { label: string; value: string; data: any },
    input: string
  ) => {
    //console.log('candidate=', candidate, ' input=', input);
    if (input === "") {
      return true;
    }
    for (let col of columns) {
      //console.log('col=', col);
      let itemValue = candidate.data[col.name];
      if (input && input.length > 0 && itemValue && itemValue.length > 0) {
        itemValue = itemValue.toLowerCase();
        input = input.toLowerCase();
        let result = itemValue.indexOf(input) > -1;
        //console.log('col.name =', col.name, ' result=', result);
        if (result) {
          return result;
        }
      }
    }
    return false;
  };

  let comp: any = {
    animatedComponents,
  };

  let additionalProps: any = {};
  let customProps: any = {};

  if (isMulti) {
    if (variant == "table") {
      customProps = {
        optionTemplate: optionTemplate || OptionTemplateMulti,
        columns,
        optionHeaderTemplate: optionHeaderTemplate || OptionHeaderTemplateMulti,
        searchColumn,
        selectAll,
        selectAllItems,
        showSelectedCount,
        localization
      };
      comp.Menu = Menu;
      comp.MenuList = MenuList;
    }
    comp.Option = MultiOption;
    comp.ValueContainer = ValueContainer;

    customProps.selected = selected;

    additionalProps.isMulti = true;
    additionalProps.closeMenuOnSelect = false;
    if (searchAcrossColumns) {
      additionalProps.filterOption = filterOption;
    }
  } else {
    if (variant == "table") {
      customProps = {
        optionTemplate: optionTemplate || OptionTemplateSingle,
        columns,
        optionHeaderTemplate:
          optionHeaderTemplate || OptionHeaderTemplateSingle,
        searchColumn,
      };
      comp.Option = SingleOption;
      comp.Menu = Menu;
      comp.MenuList = MenuList;
    }
    additionalProps.closeMenuOnSelect = true;
  }
  const getMenuWidth = () => {
    if (variant == "table") {
      if (menuWidth == 'sm') {
        return "400px";
      } else if (menuWidth == 'md') {
        return "600px";
      } else if (menuWidth == 'lg') {
        return "800px";
      } else {
        return "auto"
      }
    }
  }
  customProps = { ...customProps, menuWidth: getMenuWidth(), maxMenuHeight: menuHeight, alignDorpdownRight: alignDorpdownRight ? true : false, menuId: menuId };

  const loadOptions = async (
    inputValue: string,
    callback: (result: any) => void
  ) => {
    let response = await getOptionsAsync({ value: inputValue, searchColumn });
    callback(response);
    return response;
  };
  if (visibility === false) {
    return <></>;
  }
      
  const onBlurInput = (e:any) => {
    console.log('onBlurInput e.currentTaget.value=', e.currentTarget.value);
    const freeText = e.currentTarget?.value;
    if(freeText) {
      let selectedOption = { [valueField] : "", [displayField]: freeText };
      setSelected(selectedOption);
      onChange({ name: name, value: "no-party", data: null, freeText  });
    }
  }

  return (
    <>
      {!hideCaption && caption && (
        <label className={`r-input-control-label ${variant}`}>
          {caption}
        </label>
      )}
      <Box
        className={`fx-listselect ${mandatory ? "mandatory" : ""} ${className
          } ${color} ${size} ${error ? "error" : ""} ${success ? "success" : ""
          }`}
      >
        {dataSource == "remote" && (
          <AsyncSelect
            {...additionalProps}
            styles={customStyles}
            hideSelectedOptions={false}
            components={comp}
            onChange={handleChange}
            placeholder={placeholder}
            isDisabled={disabled}
            getOptionValue={(option: any) => option[valueField]}
            getOptionLabel={(option: any) => option[displayField]}
            value={selected}
            loadOptions={loadOptions}
            defaultOptions={true}
            noOptionsMessage={localization?.noOptionsMessage}
            onBlur={(e)=>onBlurInput(e)}
            {...customProps}
          />
        )}
        {dataSource != "remote" && (
          <ReactSelect
            options={options}
            styles={customStyles}
            {...additionalProps}
            hideSelectedOptions={false}
            placeholder={placeholder}
            components={comp}
            isDisabled={disabled}
            onChange={handleChange}
            getOptionValue={(option: any) => option[valueField]}
            getOptionLabel={(option: any) => option[displayField]}
            value={selected}
            noOptionsMessage={localization?.noOptionsMessage}
            {...customProps}
          />
        )}
      </Box>
    </>
  );
};